module.exports = __webpack_public_path__ + "img/food.ab363df1.svg";